import { render, staticRenderFns } from "./RightList.vue?vue&type=template&id=e54ec8c4&"
import script from "./RightList.vue?vue&type=script&lang=js&"
export * from "./RightList.vue?vue&type=script&lang=js&"
import style0 from "./RightList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports